import type {
  NewSealedProduct,
  SealedProduct,
  SealedProductListFilter,
  SealedStockUpdate,
} from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";

export const SEALED_FILTERS: { key: SealedProductListFilter; label: string }[] = [
  { key: "all", label: "All" },
  { key: "in-stock", label: "In stock" },
  { key: "archived", label: "Archived" },
];

/** The dialog that is open: adding a product, or counting or archiving one. */
export type SealedDialog =
  | { readonly kind: "add" }
  | { readonly kind: "stock" | "archive"; readonly product: SealedProduct };

export class SealedState {
  readonly filter = new Rx<SealedProductListFilter>("all");
  readonly search = new Rx("");
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly items = new RxList<SealedProduct>();
  readonly busyId = new Rx<string | null>(null);
  readonly dialog = new Rx<SealedDialog | null>(null);
  readonly dialogBusy = new Rx(false);
  readonly dialogError = new Rx<string | null>(null);
}

export abstract class SealedActions {
  abstract setFilter(filter: SealedProductListFilter): void;
  abstract setSearch(search: string): void;
  abstract openAdd(): void;
  abstract retry(): void;
  abstract openStock(product: SealedProduct): void;
  abstract openArchive(product: SealedProduct): void;
  abstract closeDialog(): void;
  abstract saveNew(product: NewSealedProduct): Promise<void>;
  abstract saveStock(change: SealedStockUpdate): Promise<void>;
  abstract confirmArchive(): Promise<void>;
}
